import { Pipe, PipeTransform } from '@angular/core';
import { RepoService } from '@helpers/repo/repo.service';
import { Source } from '@helpers/types/models';
import { exist, Id } from '@campaign-portal/namespace/common/id';

@Pipe({
	name: 'source'
})
export class SourcePipe implements PipeTransform {

	constructor(
		private repo: RepoService
	) {
	}

	transform(id: Id<exist> | string): Source | null {
		if ( typeof id === 'string' ) {
			id = parseInt(id, 10);
		}
		return this.repo.transformSource(id) as (Source | null);
	}

}